import React from 'react'
import ReactDOM from 'react-dom'
import videojs from 'video.js'

const vjsComponent = videojs.getComponent('Component')

export default class SettingMenu extends vjsComponent {
    constructor(player, options) {
        super(player, options)
        this.state = {
            srcOptions: options.srcOptions,
            classes: options.classes,
            classNames: options.classNames,
            setNewSourceCallback: options.setNewSourceCallback,
            selectedSrc: options.selectedSrc,
        }

        /* Bind the current class context to the mount method */
        this.mount = this.mount.bind(this)

        /* When player is ready, call method to mount React component */
        player.ready(() => {
            this.mount()
        })

        /* Remove React root when component is destroyed */
        this.on('dispose', () => {
            ReactDOM.unmountComponentAtNode(this.el())
        })
    }

    mount() {
        const { srcOptions, selectedSrc, setNewSourceCallback, classes, classNames } = this.state
        ReactDOM.render(
            <div className={classes.sourceOptionsList}>
                <div className={classes.sourceOptionHeader}>{'Video Quality'}</div>
                {srcOptions.map(srcOption => {
                    return (
                        <div
                            key={srcOption.title}
                            className={classNames(classes.sourceOptionItem, {
                                [classes.selectedSrc]: selectedSrc === srcOption.url,
                            })}
                            onClick={() => setNewSourceCallback(srcOption.url)}
                        >
                            {srcOption.title}
                        </div>
                    )
                })}
            </div>,
            this.el()
        )
    }
}
